// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vmfP","left":"styles_left__1kgIr"};